const messages = {
  'page.signup-codes-details.title': 'OnHanders using code: {code}',
  'page.signup-codes-details.table-desktop.header.name': 'Name',
  'page.signup-codes-details.table-desktop.header.date': 'Date used',
  'page.signup-codes-details.table-desktop.header.email': 'Email address',
  'page.signup-codes-details.table-desktop.header.team': 'Team joined',
  'page.signup-codes-details.table-mobile.header.name': 'Name',
  'page.signup-codes-details.table-mobile.header.date': 'Date',
  'page.signup-codes-details.table-mobile.header.team': 'Team',
  'page.signup-codes-details.stats-organisation': 'Organisation',
  'page.signup-codes-details.stats-date': 'Start date',
  'page.signup-codes-details.stats-times-used': 'Times used',
  'page.signup-codes-details.stats-status': 'Status',
  'page.signup-codes-details.btn.deactivate': 'Deactivate',
  'page.signup-codes-details.no-data.title': 'No data to display',
  'page.signup-codes-details.no-data.description': "This joining code hasn't been used yet.",
  'page.signup-codes-details.status.active': 'Active',
  'page.signup-codes-details.status.deactivated': 'Deactivated',
}

const codeNotifications = {
  'notifications.signup-codes-details.deactivate.success.title': 'Code has been deactivated',
  'notifications.signup-codes-details.deactivate.success.description':
    'The code {code} has been deactivated.',
  'notifications.signup-codes-details.deactivate.failure.title': 'Code has not been deactivated',
  'notifications.signup-codes-details.deactivate.failure.description':
    'There has been an error trying to deactive code {code}.',
}

export default {
  ...messages,
  ...codeNotifications,
}
